// Function loadIwpApplicationForm loads the IwpApplicationForm class by dynamically importing the js on demand if needed

export function loadIwpApplicationForm($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-iwp-application-form-chunk" */ '../widgets/iwpApplicationForm').then(wg => {

		const { IwpApplicationForm } = wg;

		let $wg = $parentEl.querySelector('[data-wg="IwpApplicationForm"]');

		if(!$wg) {
			// console.info('IwpApplicationForm: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="IwpApplicationForm"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new IwpApplicationForm($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new IwpApplicationForm($wg);
		}


	}).catch(error => error+'An error occurred while loading the IwpApplicationForm widget');

}
